import ApiBudgety from '@/api/apiBudgety'
import { MenusSistema } from '@/Helper/Segurity'

export const gastoService = {
  eliminarGastoById,
  guardarGastoPresupuesto,
  getGastoByIdPresupuesto,
  getGastosResumenByIdPresupuesto,
  guardarGastoPresupuestoRange,
  guardarRedistribucion,
}

async function eliminarGastoById(id, idusuario) {
  return await ApiBudgety.post('Gasto/DeleteById/' + idusuario + '/' + id, null, {
    headers: {
      ACCION: MenusSistema.presupuesto_asignado.accesos.asignar_linea_gasto,
      MENU: MenusSistema.presupuesto_asignado.id,
    },
  })
}

async function guardarGastoPresupuesto(idusuario, gastoPresupuesto) {
  return await ApiBudgety.post('Gasto/InsertOrUpdate/' + idusuario, gastoPresupuesto, {
    headers: {
      ACCION: MenusSistema.presupuesto_asignado.accesos.asignar_linea_gasto,
      MENU: MenusSistema.presupuesto_asignado.id,
    },
  })
}

async function getGastoByIdPresupuesto(id) {
  return await ApiBudgety.get('Gasto/FindByIdPresupuesto/' + id)
}

async function getGastosResumenByIdPresupuesto(id) {
  return await ApiBudgety.get('Gasto/FindByIdPresupuestoIncludeMovimientos/' + id)
}

async function guardarGastoPresupuestoRange(idusuario, gastoPresupuesto) {
  return await ApiBudgety.post('Gasto/InsertOrUpdateRange/' + idusuario, gastoPresupuesto, {
    headers: {
      ACCION: MenusSistema.presupuesto_asignado.accesos.asignar_linea_gasto,
      MENU: MenusSistema.presupuesto_asignado.id,
    },
  })
}

async function guardarRedistribucion(idusuario, gasto) {
  return await ApiBudgety.post('Gasto/Redistribucion/' + idusuario, gasto, {
    headers: {
      ACCION: MenusSistema.presupuesto_asignado.accesos.redistribuir_montos,
      MENU: MenusSistema.presupuesto_asignado.id,
    },
  })
}
